import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-onlinelook-2022-tab4',
  templateUrl: './tab4.component.html',
  styleUrls: ['./tab4.component.styl']
})
export class OnlinelookTab4Component implements OnInit {

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit() {

  }

}
